import { useGetHttp } from "../../../../hooks/http/http.hook";
import type { IUser } from "../../../../types/models/user.models.types";

export interface IComment {
  id: string;
  message: string;
  addedByUser: IUser;
  createdAt: Date;
  updatedAt: Date;
}

interface IResponse {
  comments: Array<IComment>;
}

export function useGetProposalSocialCommentsHttp() {
  return useGetHttp<IResponse>({
    path: "/brand/campaigns/proposals/:proposalId/socials/:proposalSocialId/comments",
  });
}
